import { DBResultsByType, IAudience, ICampaign, ICampaignBlueprint, IReactivation, IEmail, IExclusion, IOrg } from '@/store/types';
import Axios from '@/helpers/axios-wrapper';
import CampaignService from './campaign.service';

const RESOURCE = '/api/reactivation';

export default {
  ...CampaignService(RESOURCE),
};
